import React from 'react';
import { useTranslation } from 'react-i18next';

import { errorKey } from '@/lib/utils/errors';

import { EmptyState } from './EmptyState';

export interface ErrorStateProps {
  /** The caught error - mapped to a friendly localized message. */
  error?: unknown;
  onRetry?: () => void;
  className?: string;
}

export function ErrorState({ error, onRetry, className }: ErrorStateProps) {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon="cloud-offline-outline"
      title={t('common.errorTitle')}
      body={error !== undefined ? t(errorKey(error)) : t('common.errorBody')}
      actionLabel={onRetry ? t('common.retry') : undefined}
      onAction={onRetry}
      className={className}
    />
  );
}
